import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate, Link } from 'react-router-dom'; 
import Footer from './Footer.js'; 
import { Spinner } from 'react-bootstrap'; 
import { Alert } from 'react-bootstrap'; 
import { BASE_URL } from "./Constants.js";

const Manage_DressType = () => {
  const [users, setUsers] = useState([]); 
  const [filteredUsers, setFilteredUsers] = useState([]); 
  const [user, setUser] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [currentPage, setCurrentPage] = useState(1); 
  const [itemsPerPage, setItemsPerPage] = useState(10); 
  const navigate = useNavigate();

  const handleAddDressType = () => {
    navigate('/add_dresstype');
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); 
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch dress types');
        }

        const data = await response.json();
        if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
          const activeDressTypes = data.dressTypes.filter(user => user.status === 'A');
          setUsers(activeDressTypes);
          setFilteredUsers(activeDressTypes); 
        } else {
          setError('No dress types found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (query === '') {
      setFilteredUsers(users); 
    } else {
      const filteredData = users.filter((user) =>
        user.dress_type.toLowerCase().includes(query) ||
      user.gender.toLowerCase().includes(query)
      );
      setFilteredUsers(filteredData);
    }
    setCurrentPage(1); // Reset to the first page on new search
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page on change of items per page
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(`Are you sure you want to deactivate ${id}?`);
  
    if (confirmDelete) {
      const token = localStorage.getItem('authToken'); 
  
      const formData = new FormData();
      formData.append('id', id);
  
      fetch(`${BASE_URL}delete_dresstype`, {
        method: 'POST', 
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData, 
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            window.location.href = window.location.href; 
          } else {
            alert('Failed to deactivate the dress type. Please try again.');
          }
        })
        .catch(err => {
          console.error('Error:', err);
          alert('An error occurred while deactivating the dress type.');
        });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <HeaderMobile />
        <Sidebar isOpen={isSidebarOpen} />
        <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen}/>
          <div className="main-content">
            <div className="section__content section__content--p30">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      {user === 'Y' && (
                        <button
                          className="btn btn-primary btn-lg"
                          onClick={handleAddDressType}
                        >
                          <i className="fas fa-plus"></i> Add Dress Type
                        </button>
                      )}

                      {/* Search and Rows Per Page Selector in Same Row */}
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Dress Type"
                            value={searchQuery}
                            onChange={handleSearch}
                          />
                        </div>
                        <div className="d-flex align-items-center">
                          <label htmlFor="rowsPerPage" className="form-label me-2">Rows:</label>
                          <select
                            id="rowsPerPage"
                            className="form-control"
                            style={{ width: 'auto' }}
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive table--no-card m-b-30">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th>Dress Type</th>
                            <th>Gender</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentUsers.length > 0 ? (
                            currentUsers.map((user, index) => (
                              <tr key={user.dress_type}>
                                <td>{index + 1}</td>
                                <td>{user.dress_type}</td>
                                 <td>{user.gender}</td>
                                <td>
                                  <Link to={`/get_dress_types/${user.id}`}>
                                    <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green' }}></i>
                                  </Link>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  <button onClick={() => handleDelete(user.id)} style={{ color: 'red' }}>
                                    <i className="fas fa-trash-alt" style={{ fontSize: '18px' }}></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr><td colSpan="4" className="text-center">No dress types found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="btn btn-sm btn-outline-secondary mx-1"
                      >
                        Prev
                      </button>

                      {[...Array(totalPages).keys()].map(pageNumber => (
                        <button
                          key={pageNumber}
                          onClick={() => paginate(pageNumber + 1)}
                          className={`btn btn-sm ${currentPage === pageNumber + 1 ? 'btn-primary' : 'btn-outline-secondary'} mx-1`}
                        >
                          {pageNumber + 1}
                        </button>
                      ))}

                      <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="btn btn-sm btn-outline-secondary mx-1"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Manage_DressType;
